import type { DevModeLifecycleHookEvent } from '@cli-types/next-adapter/generators.js'
export function lifecycleHookId(event: DevModeLifecycleHookEvent): string {
  return event.replace(/([A-Z])/g, '-$1').toLowerCase()
}
